import * as keyboard from './keyboard';
import * as mouse from './mouse';
import * as gamepad from './gamepad';

export {
    keyboard,
    mouse,
    gamepad
};



// WEBPACK FOOTER //
// ./src/client/engine/input/devices/index.ts